import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { SubscriptionAccessService } from '../subscription-access.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionAccessGuard implements CanActivate {
  constructor(
    private subscriptionAccessService: SubscriptionAccessService,
    private router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const normalized = state.url.replace(/^\/home/, '').split('?')[0] || '/dashboard';

    if (this.subscriptionAccessService.canAccessRoute(normalized)) {
      return true;
    }

    return this.router.createUrlTree(['/home/subscription'], {
      queryParams: {
        reason: 'road_domain_required',
        returnUrl: state.url,
      },
    });
  }
}
